import { useCallback } from "react";

// Segment service module for segment operations
const useSegmentService = (api) => {
  const createSegment = useCallback(
    async (segmentData, sortBy = "created_at:desc") => {
      console.log("SegmentService: createSegment called", { segmentData, sortBy });
      try {
        const requestBody = {
          name: segmentData.name,
          description: segmentData.description || "",
          filters: segmentData.filters,
          isActive: true,
        };
        const response = await api.post(`/${segmentData.moduleName}/segment`, requestBody, {
          params: {
            sortBy: sortBy,
          },
        });
        return {
          data: response.data,
          status: response.status,
        };
      } catch (error) {
        console.error("Error creating segment:", error);
        throw error;
      }
    },
    [api]
  );

  const updateSegment = useCallback(
    async (segmentData, segmentId, moduleName) => {
      console.log("SegmentService: updateSegment called", { segmentData, segmentId, moduleName });
      try {
        const response = await api.put(`/${moduleName}/segment/${segmentId}`, segmentData);
        return {
          data: response.data,
          status: response.status,
        };
      } catch (error) {
        console.error("Error updating segment:", error);
        throw error;
      }
    },
    [api]
  );

  const getAllSegments = useCallback(
    async (moduleName) => {
      console.log("SegmentService: getAllSegments called");
      try {
        const response = await api.get(`/${moduleName}/segment`);
        return {
          data: response.data,
          status: response.status,
        };
      } catch (error) {
        console.error("Error fetching segments:", error);
        throw error;
      }
    },
    [api]
  );

  const getSegment = useCallback(
    async (segmentId, moduleName) => {
      console.log("SegmentService: getSegment called", { segmentId, moduleName });
      try {
        const response = await api.get(`/${moduleName}/segment/${segmentId}`);
        return {
          data: response.data,
          status: response.status,
        };
      } catch (error) {
        console.error("Error fetching segment:", error);
        throw error;
      }
    },
    [api]
  );

  const deleteSegment = useCallback(
    async (segmentId, moduleName) => {
      console.log("SegmentService: deleteSegment called", { segmentId, moduleName });
      try {
        const response = await api.delete(`/${moduleName}/segment/${segmentId}`);
        return {
          data: response.data,
          status: response.status,
        };
      } catch (error) {
        console.error("Error deleting segment:", error);
        throw error;
      }
    },
    [api]
  );

  return {
    createSegment,
    updateSegment,
    getAllSegments,
    getSegment,
    deleteSegment,
  };
};

export default useSegmentService;
